/**
 * Emoji blocking for free-text that syncs to Dynamics (DF-349).
 *
 * Emojis in a delivery note break the CRM sync, so the portal keeps them out of
 * the field entirely rather than stripping them on save. This is the shared
 * matcher: pictographs, flag pairs (regional indicators), and the joiners and
 * variation/keycap marks that dress a character up as an emoji.
 */
const EMOJI_PATTERN =
  /\p{Extended_Pictographic}|\p{Emoji_Presentation}|\p{Regional_Indicator}|[️⃣‍]/gu

/** True if the text contains any emoji character. */
export function containsEmoji(text: string): boolean {
  // Reset lastIndex: the pattern is global, so test() is otherwise stateful.
  EMOJI_PATTERN.lastIndex = 0
  return EMOJI_PATTERN.test(text)
}

/** The text with every emoji character removed. */
export function stripEmoji(text: string): string {
  return text.replace(EMOJI_PATTERN, '')
}
